import classnames from 'classnames';
import React, { ReactElement, ReactNode } from 'react';

import * as styles from './Grid.module.scss';

export type Gap = 'micro' | 'small' | 'semi' | 'smallest' | 'large' | 'standard';

export type GridProps = {
  children: ReactElement | ReactElement[] | ReactNode;
  desktop?: boolean | string;
  desktopMedium?: string;
  desktopLarge?: string;
  desktopExtraLarge?: string;
  tablet?: boolean | string;
  className?: any | string;
  gap?: boolean | Gap;
  justifyItems?: string;
  alignItems?: string;
  justifyContent?: string;
  alignContent?: string;
};

type CellProps = {
  children: ReactElement | ReactElement[] | ReactNode;
  className?: any | string;
  colspan?: string;
  justifyEnd?: boolean;
  testId?: string;
};

export const Cell = ({ children, className, colspan, justifyEnd, testId }: CellProps): JSX.Element => (
  <div
    data-test-id={testId}
    className={classnames({
      [className]: className,
      [styles['Container__Cell']]: true,
      [styles['Container__Cell__justify--end']]: justifyEnd,
      [styles[`Container__Cell__colspan-${colspan}`]]: colspan,
    })}
  >
    {children}
  </div>
);

export const Grid = ({
  children,
  className,
  justifyContent,
  justifyItems,
  alignContent,
  alignItems,
  gap = 'micro',
  tablet = false,
  desktop = false,
  desktopMedium = undefined,
  desktopLarge = undefined,
  desktopExtraLarge = undefined,
}: GridProps): JSX.Element => (
  <div
    className={classnames({
      [className]: className,
      [styles['Container']]: true,
      [styles[`Container__tablet-col${tablet}`]]: tablet,
      [styles[`Container__desktop-col${desktop}`]]: desktop,
      [styles[`Container__desktopMedium-col${desktopMedium}`]]: desktopMedium,
      [styles[`Container__desktopLarge-col${desktopLarge}`]]: desktopLarge,
      [styles[`Container__desktopExtraLarge-col${desktopExtraLarge}`]]: desktopExtraLarge,
      [styles[`Container__gap-${gap}`]]: gap,
      [styles[`Container__justifyItems-${justifyItems}`]]: justifyItems,
      [styles[`Container__justifyContent-${justifyContent}`]]: justifyContent,
      [styles[`Container__alignItems-${alignItems}`]]: alignItems,
      [styles[`Container__alignContent-${alignContent}`]]: alignContent,
    })}
  >
    {children}
  </div>
);
